export default __webpack_public_path__ + "static/media/Rene-Ter.0b10659b.png";